import React from "react";
import { useSelector } from "react-redux";
import RedirectRoute from "../RedirectRoute";
const ClaimDashboard = () => {
  const clientSettings = useSelector(state => state.common.clientSettings);
  const menuItems = useSelector(state => state.common.menuItems);
  const trackClaimMenu = menuItems.find(
    x =>
      x.children &&
      x.children.find(
        c => c.id === "FlexBenefitsMain_TrackClaims" || c.id === "FlexBenefitsMain_PendingClaims"
      )
  );
  return clientSettings && clientSettings.newUIFlag && trackClaimMenu ? (
    <RedirectRoute exact path="/claims" to="/claims/track" />
  ) : (
    <RedirectRoute exact path="/claims" to="/claims/accounts" />
  );
};

export default ClaimDashboard;



// WEBPACK FOOTER //
// ./components/claim/ClaimDashboard.js